var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessCheckFill({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    rx: 9,
    fill: "#54C367"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5901 5.51445C13.9618 5.87488 13.971 6.4684 13.6106 6.84012L8.51993 12.0901C8.34325 12.2723 8.10024 12.3751 7.84644 12.375C7.59264 12.3749 7.34973 12.2719 7.17322 12.0895L4.76385 9.60011C4.40376 9.22806 4.41346 8.63455 4.7855 8.27446C5.15755 7.91437 5.75106 7.92407 6.11115 8.29611L7.8475 10.0901L12.2645 5.53488C12.6249 5.16317 13.2184 5.15402 13.5901 5.51445Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessCheckFill);
export default __webpack_public_path__ + "static/media/SuccessCheckFill.8b7f108233caeee2588ed22da11cdf36.svg";
export { ForwardRef as ReactComponent };